import axios from "../../../../../../utils/request"

function GET_LISTS(params) {
    return axios.get("/translation/BatchRewritePrompt/index", {
        params: {
            ...params
        }
    } )
}
function EDIT_DATAS(params) {
    return  axios.post("/translation/BatchRewritePrompt/edit",
        {id:params}
    )
}
function SUBMIT_ADDS(params) {
    return  axios.post("/translation/BatchRewritePrompt/addPost",{...params} )
}

function SUBMIT_EDITS(params) {
    return  axios.post("/translation/BatchRewritePrompt/editPost",{...params} )
}


function DELES(params) {
    return  axios.get("/translation/BatchRewritePrompt/delete",{
        params: {
            ids:params
        }
    } )
}
export default {
    GET_LISTS,
    EDIT_DATAS,
    SUBMIT_ADDS,
    SUBMIT_EDITS,
    DELES,
}
